import React, { useState } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";

const FeeTypeSelect = ({ checkedType, setCheckedType, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [types, setTypes] = useState([
    "payout",
    "payment"
  ]);

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedType(data);
  };

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">{t("feeTypeSelect.title")}</InputLabel>
      {/* No need to change on Autocomplete component (few options) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedType}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>{t("feeTypeSelect.all")}</MenuItem>}
        {types.map((status, key) => (
          <MenuItem
            key={key}
            value={status}
          >
            {status}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FeeTypeSelect;